export default "__VITE_ASSET__CLPTWZXE__"